import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import H4 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H4';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';
import Image from '@bitcoin-portal/bitcoincom-pkg-components/dist/Image';
import Loader from '@bitcoin-portal/bitcoincom-pkg-components/dist/Loader';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import QRCode from 'qrcode.react';
import { Helmet } from 'react-helmet';

import SEO from '../../components/SEO';
import DownloadLinks from './DownloadLinks';
import { Card, Container, ErrorMessage } from './styled';

const Home = () => {
  const [qrLink, setQrLink] = useState('');
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadBranch = async () => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://cdn.branch.io/branch-latest.min.js';
      script.onload = () => {
        if (window.branch) {
          window.branch.init(
            'key_live_aeTLU6rLIdXDWrNdMPxrBfcnwynRJhTj',
            (er, data) => {
              setLoaded(true);
              console.log('branch initialized', data);
              if (er) {
                console.log('error initializing branch', er);
              }
              if (data.data_parsed.$deeplink_path) {
                const qrLinkConcatenated = `${data.data_parsed.$deeplink_path}&sweep_salt=${data.data_parsed.pl_ref}`;
                setQrLink(qrLinkConcatenated);
              }
            },
          );
        }
      };
      script.onerror = er => {
        setLoaded(true);
        console.log('error loading branch', er);
      };
      document.head.appendChild(script);
    };
    loadBranch();
  }, [setQrLink]);

  return (
    <>
      <SEO page="payment" />
      <Helmet>
        <script
          src={
            process.env.MPC_WIDGET_URL ||
            'https://widget.bitcoin.com/widget.v0.7.14.iife.js'
          }
          type="text/javascript"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf"
          as="font"
          type="font/ttf"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@500..900&family=Noto+Sans:ital,wdth,wght@0,75..100,500..900;1,62.5..100,500..900&display=swap"
          rel="stylesheet"
          key="google-fonts2"
        />

        <style>
          {`
                  @font-face {
                    font-family: 'Elza Condensed';
                    src: url('https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff') format('woff');
                    font-style: normal;
                    font-display: swap;
                  }
                  @font-face {
                    font-family: 'Satoshi Variable Medium';
                    src: url('https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff') format('woff');
                    font-weight: normal;
                    font-style: normal;
                    font-display: swap;
                  }
                  @font-face {
                    font-family: 'Chivo Mono';
                    src: url('https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf') format('truetype');
                    font-weight: normal;
                    font-style: normal;
                    font-display: swap;
                  }
                `}
        </style>
      </Helmet>
      <div style={{ background: '#F7F9FD', height: '100vh' }}>
        <Section>
          <ContentBlock>
            <div
              style={{
                flexBasis: '100%',
                maxWidth: '896px',
                padding: 8,
                boxSizing: 'border-box',
                margin: '0 auto 16px',
              }}
            >
              <img
                src="/images/uploads/desktop-logo.webp"
                alt="Bitcoin.com Logo"
                width="188px"
                height="auto"
              />
            </div>
            <Container columns={2}>
              <Card>
                <H4
                  style={{
                    display: 'flex',
                    textAlign: 'center',
                    alignItems: 'center',
                    fontFamily: "'Elza Condensed', sans-serif",
                    fontWeight: 500,
                  }}
                >
                  <FormattedMessage id="payment.scan.title" />
                </H4>
                <Paragraph
                  style={{
                    fontWeight: 500,
                    fontSize: '16px',
                    textAlign: 'center',
                    maxWidth: 309,
                    fontFamily: "'Satoshi Variable Medium', sans-serif",
                  }}
                >
                  <FormattedMessage
                    id="payment.scan.subtitle"
                    values={{
                      scan: (
                        <span
                          style={{
                            fontWeight: 'bold',
                            overflow: 'visible',
                            display: 'inline-flex',
                            alignItems: 'center',
                            position: 'relative',
                            paddingLeft: 22,
                          }}
                        >
                          <img
                            src="/images/uploads/qr-code-scan.png"
                            alt="Scan"
                            height="18"
                            width="18"
                            style={{ position: 'absolute', left: 0 }}
                          />{' '}
                          <FormattedMessage id="payment.scan.scan" />
                        </span>
                      ),
                    }}
                  />
                </Paragraph>
                {qrLink && loaded && (
                  <QRCode
                    value={qrLink}
                    size={276}
                    imageSettings={{
                      src: '/images/uploads/bchicon.png',

                      height: 69,
                      width: 69,
                    }}
                  />
                )}
                {!loaded && <Loader />}
                {!qrLink && loaded && (
                  <ErrorMessage>
                    <FormattedMessage id="payment.scan.error" />
                  </ErrorMessage>
                )}
              </Card>
              <Card
                style={{
                  background:
                    'radial-gradient(86.59% 86.58% at 47.22% 17.74%, #35415C 0%, #121723 100%), #FFFFFF',
                }}
              >
                <Image
                  src="/images/uploads/intro.png"
                  alt="intro"
                  height="auto"
                />
                <H4 style={{ color: 'white', textAlign: 'center' }}>
                  <FormattedMessage id="payment.download.title" />
                </H4>
                <DownloadLinks center />
              </Card>
            </Container>
          </ContentBlock>
        </Section>
      </div>
    </>
  );
};

export default Home;
